import { render, staticRenderFns } from "./DistortionEdit.vue?vue&type=template&id=4dc7855f&scoped=true&"
import script from "./DistortionEdit.vue?vue&type=script&lang=js&"
export * from "./DistortionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc7855f",
  null
  
)

export default component.exports